var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChangesRequested({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.475 6.5375L7.4125 8.6C7.025 8.9875 7.025 9.6125 7.4125 10L14.9125 17.5H18.3687V14.0437L10.8687 6.54375C10.4812 6.15625 9.85625 6.15625 9.46875 6.54375L9.475 6.5375ZM17.125 14.5625V16.25H15.4375L10.7875 11.6L12.475 9.9125L17.125 14.5625ZM11.5938 9.025L9.90625 10.7125L8.4875 9.29375L10.175 7.60625L11.5938 9.025Z",
    fill: "#BB4D00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 1.25V6.25H13.375V5H16.45C15.0437 3.41875 13.0375 2.5 10.875 2.5C6.74375 2.5 3.375 5.8625 3.375 10C3.375 14.1375 6.74375 17.5 10.875 17.5H11.5V18.75H10.875C6.05 18.75 2.125 14.825 2.125 10C2.125 5.175 6.05 1.25 10.875 1.25C13.2687 1.25 15.5 2.21875 17.125 3.89375V1.25H18.375Z",
    fill: "#BB4D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChangesRequested);
export default __webpack_public_path__ + "static/media/ic-changes-requested.47674f9b05d4474d98caf690007c8bca.svg";
export { ForwardRef as ReactComponent };